import React from 'react'
import SimpleTextBox from '../SimpleTextBox'
import SimpleTextAccordion from '../SimpleTextAccordion'
import { DASGBOARDNOW_SECTION } from 'pages/Output/DashboardNowcasting/constants'
import '../../index.scss'

const SubGridTitle = ({ config, data, setData, t }) => {
  const { value, ...otherconfig } = config
  return (
    <div className='ovs-main-container-item'>
      <div
        class='ovs-grid-wrapper'
        style={{
          '--rowNum': 1,
          '--colNum': 1,
          '--gridHeight': `3vh`
        }}
      >
        <div className='ovs-grid-wrapper-item first-column'>
          {config?.accordion ? (
            <SimpleTextAccordion
              value={t(`${DASGBOARDNOW_SECTION}.${value?.toUpperCase()}`)}
              {...otherconfig}
              data={data}
              setData={setData}
            ></SimpleTextAccordion>
          ) : (
            <SimpleTextBox
              {...otherconfig}
              value={t(`${DASGBOARDNOW_SECTION}.${value?.toUpperCase()}`)}
            ></SimpleTextBox>
          )}
        </div>
      </div>
    </div>
  )
}

export default SubGridTitle
